import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const RssFeedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 185px);
  min-height: calc(100vh - 185px);
  padding: 24px 24px 51px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

export const NoResultsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const NoResultsText = styled(typography.TitleOneRegularTypography)``;

export const ImgPreview = styled.img`
  max-width: 90vw;
  max-height: 90vh;
`;

export const VideoPreview = styled.video`
  max-width: 90vw;
  max-height: 90vh;
`;

export const VideoPreviewSrc = styled.source``;

export const ToastTextOverlay = styled.div`
  position: fixed;
  bottom: 40px;
  left: 50%;
  margin-left: -10px;
  padding: 15px 30px;
  color: white;
  background-color: ${({ theme }) => theme.colors.overlay};
  border-radius: 10px;
  z-index: 1;
`;
